import { render, staticRenderFns } from "./CampDetail.vue?vue&type=template&id=aa187860&scoped=true&lang=pug"
import script from "./CampDetail.vue?vue&type=script&lang=js"
export * from "./CampDetail.vue?vue&type=script&lang=js"
import style0 from "./CampDetail.vue?vue&type=style&index=0&id=aa187860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa187860",
  null
  
)

export default component.exports